import { render, staticRenderFns } from "./UserMenuBtn.vue?vue&type=template&id=e2aa20ec&scoped=true"
import script from "./UserMenuBtn.vue?vue&type=script&lang=ts"
export * from "./UserMenuBtn.vue?vue&type=script&lang=ts"
import style0 from "./UserMenuBtn.vue?vue&type=style&index=0&id=e2aa20ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2aa20ec",
  null
  
)

export default component.exports